module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper gallery-wrapper"
  }, [_c('div', {
    staticClass: "jumbotron jumbotron-fluid"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Coming Soon!")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_c('strong', [_vm._v("\n          Stay tuned!\n      ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1d8361e3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 371
// module chunks = 2